import { axios } from '@util';
import store from '@store';

class ExportsService {
	/**
	 * Retrieves a collection of exports.
	 *
	 * @param {boolean} mutate Whether to mutate store management state.
	 * @returns Promise
	 */
	async getExports(mutate = true) {
		const rs = await axios({
			url: `/saved_exports/`,
		});

		if (mutate) store.commit('GET_EXPORTS', rs.data.data.results);

		return rs;
	}

	/**
	 * Retrieve an item from the collection of exports.
	 *
	 * @param {int} id The export id.
	 * @param {boolean} mutate Whether to mutate store management state.
	 * @returns Promise
	 */
	async getExport(id, mutate = true) {
		const rs = await axios({
			url: `/saved_exports/${id}/`,
		});

		if (mutate) store.commit('GET_EXPORT', rs.data.data.data);

		return rs;
	}

	/**
	 * Creates an item from the collection of exports.
	 *
	 * @param {object} payload The export payload data.
	 * @param {string} name The export name.
	 * @param {int} created_by The export creator user id.
	 * @param {string} occurrence The export occurrence. (Weekly|Monthly)
	 * @param {boolean} status The export status.
	 * @param {boolean} mutate Whether to mutate store management state.
	 * @returns Promise
	 */
	async saveExport(
		id = null,
		payload,
		name,
		created_by,
		occurrence = 'Weekly',
		time_of_day = null,
		start_date = null,
		end_date = null,
		day_of_week = null,
		day_of_month = null,
		timezone = null,
		status = true,
		mutate = true
	) {
		const createMode = null === id;
		const rs = await axios({
			url: createMode ? `/saved_exports/` : `/saved_exports/${id}/`,
			method: createMode ? 'POST' : 'PATCH',
			data: {
				name: name,
				created_by: created_by,
				payload: JSON.stringify(payload),
				occurrence: occurrence,
				time_of_day: time_of_day,
				start_date: start_date,
				end_date: end_date,
				day_of_week: day_of_week,
				day_of_month: day_of_month,
				timezone: timezone,
				status: status,
			},
		});

		if (mutate)
			store.commit(
				createMode ? 'SAVE_EXPORT' : 'UPDATE_EXPORT',
				rs.data.data.data
			);

		return rs;
	}

	/**
	 * Deletes an item from the collection of exports.
	 *
	 * @param {int} id
	 * @param {boolean} mutate Whether to mutate store management state.
	 * @returns Promise
	 */
	async deleteExport(id, mutate = true) {
		const rs = await axios({
			url: `/saved_exports/${id}/`,
			method: 'DELETE',
		});

		if (mutate) store.commit('DELETE_EXPORT', id);

		return rs;
	}

	/**
	 * Unset an item from the collection of exports.
	 */
	unsetExport() {
		store.commit('GET_EXPORT', {});
	}
}

export default new ExportsService();
